import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const UnderlineIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M9.99984 14.1667c2.75836 0 4.99996-2.2417 4.99996-5.00003V2.5h-2.0833v6.66667c0 1.60833-1.3083 2.91663-2.91666 2.91663-1.60834 0-2.91667-1.3083-2.91667-2.91663V2.5H4.99984v6.66667c0 2.75833 2.24166 5.00003 5 5.00003ZM4.1665 15.8333V17.5h11.6667v-1.6667H4.1665Z" />
  </Icon>
);

export default memo(UnderlineIcon);
